import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/LanguageContext";
import { Globe } from "lucide-react";
import { cn } from "@/lib/utils";

interface LanguageToggleProps {
  className?: string;
}

export const LanguageToggle = ({ className = "" }: LanguageToggleProps) => {
  const { language, setLanguage, translate } = useLanguage();

  const toggleLanguage = () => {
    setLanguage(language === "en" ? "de" : "en");
  };

  return (
    <Button
      onClick={toggleLanguage}
      variant="outline"
      size="sm"
      className={cn(
        "h-8 px-2 gap-1 text-xs sm:h-9 sm:px-2.5 [&_svg]:size-3.5 sm:[&_svg]:size-4",
        className
      )}
      title={translate("language.switch.to")}
    >
      <Globe className="shrink-0" />
      <span>{language === "en" ? "DE" : "EN"}</span>
    </Button>
  );
};
